import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "content-box-form" }
const _hoisted_2 = { class: "form" }
const _hoisted_3 = { class: "input-row" }
const _hoisted_4 = {
  key: 0,
  class: "error"
}
const _hoisted_5 = { class: "input-row" }
const _hoisted_6 = {
  key: 0,
  class: "error"
}
const _hoisted_7 = {
  key: 1,
  class: "error"
}
const _hoisted_8 = { class: "input-row" }
const _hoisted_9 = {
  key: 0,
  class: "error"
}
const _hoisted_10 = { class: "input-row" }
const _hoisted_11 = {
  key: 0,
  class: "error"
}
const _hoisted_12 = { class: "input-row" }
const _hoisted_13 = {
  key: 0,
  class: "error"
}
const _hoisted_14 = {
  class: "dropdown-button input-dropdown option-label",
  type: "button"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 1,
  class: "error"
}
const _hoisted_17 = { class: "input-row" }
const _hoisted_18 = {
  class: "dropdown-button input-dropdown option-label",
  type: "button"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 0,
  class: "error"
}
const _hoisted_21 = {
  class: "dropdown-button input-dropdown option-label",
  type: "button"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 1,
  class: "error"
}
const _hoisted_24 = { class: "input-row" }
const _hoisted_25 = {
  key: 0,
  class: "error"
}
const _hoisted_26 = { class: "agree" }
const _hoisted_27 = { class: "content-submit" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 0,
  class: "spinner spinner-small"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "sign-in" }, [
      _cache[8] || (_cache[8] = _createTextVNode(" Already have an account? ", -1)),
      _createElementVNode("span", {
        class: "bold",
        onClick: $setup.onSingIn
      }, "Sign in")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          class: "input-default",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.email) = $event)),
          type: "email",
          placeholder: "Email address"
        }, null, 512), [
          [_vModelText, $setup.form.email]
        ]),
        ($setup.v$.email.$error)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($setup.v$.email.required.$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          class: "input-default",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.firstName) = $event)),
          placeholder: "First name"
        }, null, 512), [
          [_vModelText, $setup.form.firstName]
        ]),
        ($setup.v$.firstName.$error)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString($setup.v$.firstName.required.$message), 1))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("input", {
          class: "input-default",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.lastName) = $event)),
          placeholder: "Last name"
        }, null, 512), [
          [_vModelText, $setup.form.lastName]
        ]),
        ($setup.v$.lastName.$error)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString($setup.v$.lastName.required.$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode($setup["Cleave"], {
          class: "input-default",
          placeholder: "Phone number",
          modelValue: $setup.form.phoneNumber,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.phoneNumber) = $event)),
          options: $setup.phoneNumberOption($setup.form.phoneNumber)
        }, null, 8, ["modelValue", "options"]),
        ($setup.v$.phoneNumber.$error)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString($setup.v$.phoneNumber.$errors[0]?.$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _withDirectives(_createElementVNode("input", {
          class: "input-default",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.company) = $event)),
          placeholder: "Company"
        }, null, 512), [
          [_vModelText, $setup.form.company]
        ]),
        ($setup.v$.company.$error)
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString($setup.v$.company.required.$message), 1))
          : _createCommentVNode("", true)
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "details" }, "Project Details", -1)),
      _createElementVNode("div", _hoisted_12, [
        _withDirectives(_createElementVNode("input", {
          class: "input-default suburb",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.suburb) = $event)),
          placeholder: "Suburb"
        }, null, 512), [
          [_vModelText, $setup.form.suburb]
        ]),
        ($setup.v$.suburb.$error)
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString($setup.v$.suburb.required.$message), 1))
          : _createCommentVNode("", true),
        _createVNode($setup["DropDown"], { class: "dropdown-container-state" }, {
          control: _withCtx(() => [
            _createElementVNode("label", _hoisted_14, _toDisplayString($setup.form.state), 1)
          ]),
          dropdown: _withCtx(() => [
            _createElementVNode("ul", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.optionsBuyerState, (state) => {
                return _createElementVNode("li", {
                  key: state,
                  onClick: ($event: any) => ($setup.selectBuyerState(state)),
                  class: _normalizeClass({ 'dropdown__item-active': state === $setup.form.state })
                }, _toDisplayString(state), 11, _hoisted_15)
              }), 64))
            ])
          ]),
          _: 1
        }),
        ($setup.v$.state.$error)
          ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString($setup.v$.state.required.$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode($setup["DropDown"], { class: "dropdown-container" }, {
          control: _withCtx(() => [
            _createElementVNode("label", _hoisted_18, _toDisplayString($setup.form.lotRanges), 1)
          ]),
          dropdown: _withCtx(() => [
            _createElementVNode("ul", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.optionsPlansLotRanges, (range) => {
                return _createElementVNode("li", {
                  key: range,
                  onClick: ($event: any) => ($setup.selectPlansLotRange(range)),
                  class: _normalizeClass({ 'dropdown__item-active': range === $setup.form.lotRanges })
                }, _toDisplayString(range), 11, _hoisted_19)
              }), 64))
            ])
          ]),
          _: 1
        }),
        ($setup.v$.lotRanges.$error)
          ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString($setup.v$.lotRanges.required.$message), 1))
          : _createCommentVNode("", true),
        _createVNode($setup["DropDown"], { class: "dropdown-container" }, {
          control: _withCtx(() => [
            _createElementVNode("label", _hoisted_21, _toDisplayString($setup.form.status), 1)
          ]),
          dropdown: _withCtx(() => [
            _createElementVNode("ul", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.optionsPlansStatus, (item) => {
                return _createElementVNode("li", {
                  key: item,
                  onClick: ($event: any) => ($setup.selectPlansStatus(item)),
                  class: _normalizeClass({ 'dropdown__item-active': item === $setup.form.status })
                }, _toDisplayString(item), 11, _hoisted_22)
              }), 64))
            ])
          ]),
          _: 1
        }),
        ($setup.v$.status.$error)
          ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString($setup.v$.item.status.$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createVNode($setup["DropdownWithCheckboxes"], {
          options: $setup.optionsPlansSalesTools,
          onChange: $setup.updateSalesTools,
          placement: "bottom"
        }),
        ($setup.v$.salesTools.$error)
          ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString($setup.v$.salesTools.required.$message), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _withDirectives(_createElementVNode("input", {
        class: "checkbox",
        type: "checkbox",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form.agree) = $event))
      }, null, 512), [
        [_vModelCheckbox, $setup.form.agree]
      ]),
      _cache[12] || (_cache[12] = _createTextVNode("I agree to the ", -1)),
      _createVNode(_component_router_link, {
        class: "link link-underline",
        to: { name: 'CustomerTerms' },
        target: "_blank"
      }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
          _createTextVNode("Terms of Service", -1)
        ]))]),
        _: 1
      }),
      _cache[13] || (_cache[13] = _createTextVNode(" and ", -1)),
      _createVNode(_component_router_link, {
        class: "link link-underline",
        to: { name: 'PrivacyPolicy' },
        target: "_blank"
      }, {
        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
          _createTextVNode("Privacy Policy", -1)
        ]))]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("button", {
        class: "button proceed",
        disabled: $setup.isLoading,
        onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.submitForm()))
      }, [
        _createTextVNode(_toDisplayString($props.isSignUpView ? "Get Started" : "Join Waitlist"), 1),
        ($setup.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29))
          : _createCommentVNode("", true)
      ], 8, _hoisted_28)
    ])
  ]))
}